function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip03)"
}, React.createElement("mask", {
  id: "mask03",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: -79,
  y: -6,
  width: 1038,
  height: 120
}, React.createElement("path", {
  className: "line-mask",
  d: "M-79 -6L-79 114L959 114V-6L-79 -6Z",
  fill: "url(#paint03_linear)"
})), React.createElement("g", {
  mask: "url(#mask03)"
}, React.createElement("path", {
  className: "dashed-line",
  opacity: 0.323863,
  d: "M-184 53.0001C-134.611 87.0063 -83.944 103.84 -32 103.5C19.944 103.161 71.2773 85.6606 122 51.0001C174.702 18.6668 227.036 2.50009 279 2.50009C330.964 2.50009 382.631 18.6668 434 51.0001C488.093 86.0001 541.093 103.5 593 103.5C644.907 103.5 695.907 86.0001 746 51.0001C798.444 18.6668 851.777 2.50009 906 2.50009C960.223 2.50009 1015.22 18.6668 1071 51.0001",
  stroke: "url(#paint13_radial)",
  strokeWidth: 4,
  strokeDasharray: "14 14"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("radialGradient", {
  id: "paint13_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(443 52.9988) rotate(180) scale(457.5 70630.6)"
}, React.createElement("stop", {
  offset: 0.744627,
  stopColor: "#00C1F1"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#00C1F1",
  stopOpacity: 0
})), React.createElement("linearGradient", {
  id: "paint03_linear",
  x1: 888.5,
  y1: 54,
  x2: 959,
  y2: 54,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "white"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), React.createElement("clipPath", {
  id: "clip03"
}, React.createElement("rect", {
  y: 106,
  width: 106,
  height: 903,
  transform: "rotate(-90 0 106)",
  fill: "white"
})));

var SvgStepsLineMobile = function SvgStepsLineMobile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 903 106",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgStepsLineMobile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/steps-line-mobile.184a4ccc.svg";
export { ForwardRef as ReactComponent };